import i18next from 'i18next';
import PasswordValidator from './PasswordValidator';

export default class PasswordReuseValidator extends PasswordValidator {
  constructor(passwordPolicy) {
    const max = passwordPolicy.passwordReuse;

    let translation = null;

    if (max !== undefined) {
      translation = i18next.t('organization.password-rules.password-reuse', { max });
    }

    super(max, 'password_reuse', true, translation);
  }
}
